import { jwtDecode } from 'jwt-decode'

import { type Token } from '@/types/Auth'

export const getTokenExpirationDate = (token: string) : Date | null => {
  const decoded = jwtDecode<Token>(token)
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!decoded.exp) {
    return null
  }

  const date = new Date(0) // The 0 here is the key, which sets the date to the epoch
  date.setUTCSeconds(decoded.exp)
  return date
}

export const isTokenExpired = (token: string) : boolean => {
  const date = getTokenExpirationDate(token)
  const offsetSeconds = 0
  if (date === null) {
    return false
  }
  return date.valueOf() <= (new Date().valueOf() + (offsetSeconds * 1000))
}
